"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var use_context_selector_1 = require("use-context-selector");
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var context_1 = require("../context");
var Step = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return (0, jsx_runtime_1.jsx)("div", tslib_1.__assign({}, rest, { children: children }));
};
exports.default = (0, houston_styles_1.default)(Step, { label: 'hst-showcase-step' })(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    var stepSize = (0, use_context_selector_1.useContextSelector)(context_1.ShowcaseContext, function (context) { return context.stepSize; });
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      width: ", "rem;\n      flex-shrink: 0;\n    "], ["\n      width: ", "rem;\n      flex-shrink: 0;\n    "])), theme.pxToRem(stepSize));
});
var templateObject_1, templateObject_2;
